/**
 * Pure helpers for the 24-hour paywall-dismiss window. Extracted from the
 * `PaywallModal` component so they can be unit-tested without a DOM.
 *
 * Semantics (per [[tasks/web-app-billing-management]] "Maybe later"):
 *   - Tapping "Maybe later" closes the modal and stores a timestamp.
 *   - For 24h thereafter we suppress automatic re-prompts.
 *   - Explicit user actions (tapping a locked card) still open the modal.
 */

export const DISMISS_KEY = "zoey_paywall_dismissed_at";
export const DISMISS_WINDOW_MS = 24 * 60 * 60 * 1000; // 24h

type ReadableStore = Pick<Storage, "getItem">;
type WritableStore = Pick<Storage, "setItem">;

function browserStore(): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function wasPaywallRecentlyDismissed(
  now: number = Date.now(),
  store: ReadableStore | null = browserStore(),
): boolean {
  if (!store) return false;
  const raw = store.getItem(DISMISS_KEY);
  if (!raw) return false;
  const ts = Number.parseInt(raw, 10);
  if (!Number.isFinite(ts)) return false;
  return now - ts < DISMISS_WINDOW_MS;
}

export function markPaywallDismissed(
  now: number = Date.now(),
  store: WritableStore | null = browserStore(),
): void {
  if (!store) return;
  store.setItem(DISMISS_KEY, String(now));
}
